export default __webpack_public_path__ + "static/media/webcam3.f43a8c62.jfif";